/**
 * DCUC pitch brand: "OnGuard | ScamDefense" co-brand and contact details,
 * matching the approved flyer (Lightbulb Press).
 */

export const DCUC_EMAIL = 'info@lightbulbpress.com'
export const DCUC_PHONE = '917-375-6640'
export const DCUC_PHONE_HREF = 'tel:+19173756640'

/** "OnGuard | ScamDefense" wordmark. `onDark` for navy backgrounds. */
export function OnGuardMark({
  onDark = true,
  className = '',
}: {
  onDark?: boolean
  className?: string
}) {
  return (
    <span className={`inline-flex items-baseline gap-2 font-bold tracking-tight ${className}`}>
      <span className="bg-gradient-to-r from-[#ff4d5e] via-white to-[#4f8cff] bg-clip-text text-transparent">
        OnGuard
      </span>
      <span className={onDark ? 'text-white/25' : 'text-slate-300'}>|</span>
      <span className={`font-semibold ${onDark ? 'text-white/85' : 'text-slate-600'}`}>
        ScamDefense
      </span>
    </span>
  )
}
